// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"sidebar--1W0Fx","opened":"opened--30LZS","link":"link--3uNkS","activeLink":"activeLink--3s_0z","icon":"icon--379il","iconProcess":"iconProcess--2khs8"};